/**
 * FrankerFaceZ
 *
 * Twitch emote extension; the web/* grant is scoped to twitch.tv.
 *
 * Behavioural discovery found no usable page-side marker, so detection falls back to
 * resource probing. The web/* grant contains both webpack chunk files (2310.js and
 * similar, whose names change every build) and stably-named bundles; the probe uses
 * avalon.js, which is a named entry point rather than a generated chunk.
 * Manifest verified against version 4.80.4.0.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'fadndhdgpmmaapbmfcknlfgcflmmmieb';
export const frankerfacez: ExtensionDefinition = {
  id: ID,
  name: "FrankerFaceZ",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  requiredOrigin: 'https://www.twitch.tv',
  notes: "Twitch emote extension; the web/* grant is scoped to twitch.tv.",
  signals: [
    { id: 'war-web-avalon-js', kind: 'web-accessible-resource',
      description: 'Fetch web/avalon.js — the main FrankerFaceZ bundle, exposed only to https://www.twitch.tv.',
      weight: 1, run: () => probeFetch(ID, 'web/avalon.js') },
  ],
};
